var _ellipse, _ellipse2, _ellipse3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAsana({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "asana",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.22,
    cy: 17.824,
    fill: "#EF5350",
    rx: 5.22,
    ry: 5.176
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 6.176,
    fill: "#EF5350",
    rx: 5.22,
    ry: 5.176
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.78,
    cy: 17.824,
    fill: "#EF5350",
    rx: 5.22,
    ry: 5.176
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsana);
export default __webpack_public_path__ + "static/media/asana.09393ad8fe15557f3ff722f93ceba4d4.svg";
export { ForwardRef as ReactComponent };